import React , { useEffect} from 'react';
import {UseSelector , useDispatch, useSelector } from 'react-redux';
import {getMainAccount ,getgoldsoldvalue,getGoldWeigth , getOutstanding} from 'slices/thunk' 
import { Package, PackageX, Truck, Wallet2 } from 'lucide-react';
import CountUp from 'react-countup';
import { RootState } from 'slices';
import WelcomeWidget from './WelcomeWidget';



const Widgets = () => {
    const dispatch = useDispatch()
    const mainAccount = useSelector((state:RootState)=>state.Ecommerce.account)
    const goldSold = useSelector((state:RootState)=>state.Ecommerce.goldSold)
    const goldWeigth=useSelector((state:RootState)=>state.Ecommerce.goldWeigth)
    const goldOutstanding = useSelector((state : RootState)=>state.Ecommerce.goldOutstanding)
    useEffect(()=>{
        dispatch(getMainAccount() as any)
        dispatch(getgoldsoldvalue() as any)
        dispatch(getGoldWeigth() as any)
        dispatch(getOutstanding() as any)
    },[dispatch])

    return (
        <React.Fragment>
            <div className="  card  col-span-2 flex items-center justify-center">
                <div className="text-center card-body ">
                    <div className="flex items-center justify-center mx-auto rounded-full size-14 bg-custom-100 text-custom-500 dark:bg-custom-500/20">
                        <Wallet2 />
                    </div>
                    <h5 className="mt-4 mb-2">$
                        <CountUp end={mainAccount?.data} decimals={2} className="counter-value " />
                    </h5>
                    <p className="text-slate-500 dark:text-zink-200">Total Revenue</p>
                </div>
            </div>
            <div className="card  col-span-2  flex items-center justify-center">
                <div className="text-center card-body">
                    <div className="flex items-center justify-center mx-auto text-purple-500 bg-purple-100 rounded-full size-14 dark:bg-purple-500/20">
                        <Package />
                    </div>
                    <h5 className="mt-4 mb-2"><CountUp end={goldWeigth?.data} className="counter-value" /> /Gm</h5>
                    <p className="text-slate-500 dark:text-zink-200">Gold Bought</p>
                </div>
            </div>
            <div className="card  col-span-2  flex items-center justify-center">
                <div className="text-center card-body">
                    <div className="flex items-center justify-center mx-auto text-green-500 bg-green-100 rounded-full size-14 dark:bg-green-500/20">
                        <Truck />
                    </div>
                    <h5 className="mt-4 mb-2"><CountUp end={goldSold?.data} className="counter-value" />/Gm</h5>
                    <p className="text-slate-500 dark:text-zink-200">Gold Sold Value</p>
                </div>
            </div>
          
              <div className="card  col-span-2  flex items-center justify-center">
                <div className="text-center card-body">
                    <div className="flex items-center justify-center mx-auto text-red-500 bg-red-100 rounded-full size-14 dark:bg-red-500/20">
                        <PackageX />
                    </div>
                    <h5 className="mt-4 mb-2"><CountUp end={goldOutstanding?.data} className="counter-value" /></h5>
                    <p className="text-slate-500 dark:text-zink-200">Outstanding Payout</p>
                </div>
            </div>
              
        </React.Fragment>
    );
};

export default Widgets;
